import React from 'react';
import { Link } from 'react-router-dom';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-md p-8 mb-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Cancellation & Refund Policy</h1>
          <p className="text-gray-600">Last updated on Oct 10 2025</p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-8 space-y-6">
          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>NEHA KEDAR KHAPARE</strong> believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              Cancellations will be considered only if the request is made within <strong>Not Applicable</strong> of placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>NEHA KEDAR KHAPARE</strong> does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within <strong>Not Applicable</strong> of receipt of the products.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within <strong>Not Applicable</strong> of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed">
              In case of any Refunds approved by the <strong>NEHA KEDAR KHAPARE</strong>, it'll take <strong>Not Applicable</strong> for the refund to be processed to the end customer.
            </p>
          </section>
        </div>

        <div className="mt-6 text-center">
          <Link to="/" className="inline-flex items-center gap-2 text-indigo-600 hover:text-indigo-700 font-semibold">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
